import { LayerEntity } from './layer-entity';
import { LetterHeadValueObject } from '../value-objects/letter-head-value-object';
import { PrintFormatEnum } from '../enums/print-format-enum';
import { LayerTypeEnum } from '../enums/layer-type-enum';

export class PrintEntity {
  constructor(
    public readonly bbox: number[],
    public readonly srid: number,
    public readonly isLandscape: boolean,
    public readonly letterHead: LetterHeadValueObject,
    public readonly pageSize: string,
    public readonly scale: number,
    public readonly outputFormat: PrintFormatEnum,
    public readonly baseLayer: LayerEntity,
    public readonly layers: LayerEntity[],
    public readonly overviewLayers: LayerEntity[],
    public readonly outSrid: number,
  ) {}

  toJSON(): Record<string, any> {
    return {
      bbox: this.bbox,
      srid: this.srid,
      isLandscape: this.isLandscape,
      letterHead: {
        owner: this.letterHead.owner,
        department: this.letterHead.department,
        province: this.letterHead.province,
        district: this.letterHead.district,
        mapName: this.letterHead.mapName,
        source: this.letterHead.source,
        author: this.letterHead.author,
      },
      pageSize: this.pageSize,
      scale: this.scale,
      output_format: this.outputFormat.toLowerCase(),
      outSrid: this.outSrid,
      baseLayer: this.serializeLayer(this.baseLayer),
      layers: this.layers.map(l => this.serializeLayer(l)),
      overviewLayers: this.overviewLayers.map(l => this.serializeLayer(l)),
    };
  }

  private serializeLayer(layer: LayerEntity): Record<string, any> {
    return {
      url: layer.url ?? '',
      type: layer.provider?.toUpperCase() ?? this.mapLayerType(layer.type),
      description: layer.name ?? '',
      definitionQuery: layer.definitionQuery ?? null,
    };
  }

  private mapLayerType(type: LayerTypeEnum): string {
    switch (type) {
      case LayerTypeEnum.MapServer:
      case LayerTypeEnum.FeatureServer:
      case LayerTypeEnum.SubServer:
        return 'ARCGIS';
      case LayerTypeEnum.WMS:
        return 'WMS';
      case LayerTypeEnum.WMTS:
        return 'WMTS';
      case LayerTypeEnum.WFS:
        return 'WFS';
      case LayerTypeEnum.KML:
        return 'KML';
      case LayerTypeEnum.GeoJson:
        return 'GEOJSON';
      case LayerTypeEnum.VectorTileServer:
        return 'VECTOR';
      default:
        return 'ARCGIS';
    }
  }
}
